import { useLanguage } from "@/i18n/LanguageContext";

const LOGOS = [
  { client: "Formula 1", logo: "/clients/f1-logo.png", h: "h-10 md:h-12" },
  { client: "FIFA World Cup", logo: "/clients/fifa-logo.png?v=2", h: "h-14 md:h-16" },
  { client: "Robb Report", logo: "/clients/robb-logo.png", h: "h-12 md:h-14" },
  { client: "Newsweek", logo: "/clients/newsweek-logo.png", h: "h-7 md:h-8" },
  { client: "The Red Bulletin", logo: "/clients/redbulletin-logo.png", h: "h-6 md:h-7" },
  { client: "Liverpool FC", logo: "/clients/liverpool-logo-white.png", h: "h-16 md:h-20" },
  { client: "Lufthansa", logo: "/clients/lufthansa-logo.png", h: "h-6 md:h-7" },
  { client: "Automobilist", logo: "/clients/automobilist-logo.png", h: "h-12 md:h-14" },
];

export default function LogoMarquee() {
  const { t } = useLanguage();
  const strip = [...LOGOS, ...LOGOS];
  return (
    <section
      data-testid="logo-marquee-section"
      aria-label="Publishers Paigez has produced for"
      className="relative border-y border-white/10 bg-white/[0.03] py-8 md:py-10 overflow-hidden"
    >
      <p className="text-center text-[10px] tracking-[0.3em] uppercase text-zinc-500 mb-7">
        {t.marquee.title}
      </p>
      <div
        dir="ltr"
        className="marquee-mask relative overflow-hidden"
        data-testid="logo-marquee-strip"
      >
        <div className="marquee-track flex items-center w-max">
          {strip.map((it, i) => (
            <img
              key={`${it.client}-${i}`}
              src={it.logo}
              alt={it.client}
              title={it.client}
              data-testid={i < LOGOS.length ? `marquee-logo-${it.client.toLowerCase().replace(/\s+/g, "-")}` : undefined}
              className={`${it.h} w-auto object-contain shrink-0 logo-mono mx-8 md:mx-12`}
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  );
}
